<script>
    export let link
</script>

<!-- Action button -->
<div class="cta-btns">
    <span class="anim-wrapper">
        <a class="btn btn-normal" href={link}>
            <span class="txt">
                <slot></slot>
            </span>
            <span class="arrow-icon"></span>
        </a>
    </span>
</div>